import type { RecurringPeriod, RecurringSettings } from '../types/RecurringSettings';

export const recurringPeriodOptions: { value: RecurringPeriod; label: string }[] = [
  { value: 'minute', label: 'Minute' },
  { value: 'hour', label: 'Hour' },
  { value: 'day', label: 'Day' },
];

export const daysOfWeekOptions = [
  { value: 1, label: 'M', name: 'Monday' },
  { value: 2, label: 'T', name: 'Tuesday' },
  { value: 3, label: 'W', name: 'Wednesday' },
  { value: 4, label: 'T', name: 'Thursday' },
  { value: 5, label: 'F', name: 'Friday' },
  { value: 6, label: 'S', name: 'Saturday' },
  { value: 0, label: 'S', name: 'Sunday' },
];

export const RECURRING_START_TIME = '00:00:00';
export const RECURRING_END_TIME = '23:59:00';

export const createDefaultRecurringSettings = (): RecurringSettings => ({
  period: 'day',
  interval: 1,
  startTime: RECURRING_START_TIME,
  endTime: RECURRING_END_TIME,
  daysOfWeek: [],
  dateStart: '',
  dateEnd: '',
});

export const normalizeRecurringSettings = (
  settings?: Partial<RecurringSettings> | null,
): RecurringSettings => {
  const defaultSettings = createDefaultRecurringSettings();
  const period = recurringPeriodOptions.some(option => option.value === settings?.period)
    ? (settings?.period as RecurringPeriod)
    : defaultSettings.period;
  const interval = Number(settings?.interval);
  const rawDaysOfWeek = settings?.daysOfWeek;
  const daysOfWeek = Array.isArray(rawDaysOfWeek)
    ? Array.from(
        new Set(
          rawDaysOfWeek
            .map(day => Number(day))
            .filter(day => Number.isInteger(day) && day >= 0 && day <= 6),
        ),
      ).sort((a, b) => a - b)
    : defaultSettings.daysOfWeek;

  return {
    period,
    interval: Number.isFinite(interval) && interval > 0 ? interval : defaultSettings.interval,
    startTime: RECURRING_START_TIME,
    endTime: RECURRING_END_TIME,
    daysOfWeek,
    dateStart: settings?.dateStart || defaultSettings.dateStart,
    dateEnd: settings?.dateEnd || defaultSettings.dateEnd,
  };
};
